<template>
    <list-page title="用户管理" :api="searchUrl" :searchParam="searchParam" :showPager="true" ref="user">
        <template v-slot:search>
            <div class="block">
                <el-input size="mini" v-model="searchParam.Key"></el-input>
            </div>
        </template>
        <template v-slot:new>
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="showAdd">新增</el-button>
        </template>
        <template v-slot:other>
            <UserEdit v-if="visible" v-model:visible="visible" :edit-model="updateModel" @refresh="getData"></UserEdit>
        </template>
        <el-table-column type="index" width="80px" label="序号"></el-table-column>
        <el-table-column prop="UserCode" label="账号"></el-table-column>
        <el-table-column prop="UserName" label="名称"></el-table-column>
        <el-table-column prop="UserName" label="角色"></el-table-column>
        <el-table-column prop="Email" label="邮箱"></el-table-column>
        <el-table-column prop="Phone" label="电话"></el-table-column>
        <el-table-column label="操作" width="300px">
            <template #default="scope">
                <el-button @click="showEdit(scope.row, scope.$index)" size="mini" icon="el-icon-edit">编辑</el-button>
                <el-button type="danger" @click="removeRow(scope.row, scope.$index)" size="mini" icon="el-icon-delete">删除</el-button>
                <el-button
                    type="warning"
                    v-if="scope.row.UserState === 1"
                    @click="disableUser(scope.row, scope.$index)"
                    size="mini"
                    icon="el-icon-close"
                    >停用</el-button
                >
                <el-button type="success" v-else size="mini" @click="enableUser(scope.row)" icon="el-icon-check">启用</el-button>
            </template>
        </el-table-column>
    </list-page>
</template>
<script>
import UserEdit from "./components/UserEdit";

export default {
    name: "User",
    components: {
        UserEdit,
    },
    data() {
        return {
            searchParam: {
                Key: "",
            },
            searchUrl: "/SysMgr/UserList",
            updateModel: null,
            visible: false,
        };
    },
    methods: {
        getData() {
            this.$refs.user.searchData();
        },
        showAdd() {
            this.updateModel = null;
            this.visible = true;
        },
        showEdit(row) {
            this.updateModel = { ...row };
            this.visible = true;
        },
        removeRow(row) {
            this.$myConfirm().then(() => {
                this.$ajax.post("/SysMgr/RemoveUser?id=" + row.UserID).then((res) => {
                    this.$success("操作成功");
                    this.getData();
                });
            });
        },
        disableUser(item, index) {
            this.$myConfirm().then(() => {
                this.$ajax.post("SysMgr/DisableUser?id=" + item.UserID).then((res) => {
                    this.$success("操作成功");
                    this.getData();
                });
            });
        },
        enableUser(item) {
            this.$myConfirm().then(() => {
                this.$ajax.post("SysMgr/EnableUser?id=" + item.UserID).then((res) => {
                    this.$success("操作成功");
                    this.getData();
                });
            });
        },
    },
    created() {},
};
</script>
